import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { App } from './App';
import { LearnerEntry } from './components/LearnerEntry';
import { LoginGate } from './auth/LoginGate';
import { msalConfig } from './auth/msalConfig';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Falta #root en index.html');

// Fase 1 "Aulas": el alumno entra por link firmado sin MSAL. Interceptamos el
// path antes de instanciar MSAL para evitar el login prompt cuando el alumno
// no tiene cuenta institucional. El backend valida el token en cada request.
const linkTokenMatch = window.location.pathname.match(/^\/entrar\/(.+)$/);
if (linkTokenMatch) {
  const token = decodeURIComponent(linkTokenMatch[1]!);
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <LearnerEntry rawToken={token} />
    </React.StrictMode>,
  );
} else {
  const msalInstance = new PublicClientApplication(msalConfig);

  // Sin setActiveAccount tras el redirect, useMsal().accounts[0] puede no estar disponible aún.
  msalInstance.initialize().then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(accounts[0] ?? null);
    }

    msalInstance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload &&
        'account' in event.payload &&
        event.payload.account
      ) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });

    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <LoginGate>
            <App />
          </LoginGate>
        </MsalProvider>
      </React.StrictMode>,
    );
  });
}
